export default __webpack_public_path__ + "static/media/logo-vw.53967511.svg";